/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.is_drawer = this.dataset.drawer;
      this.drawer = this.closest('#Search-Drawer');
      this.form = this.querySelector('form');
      this.button = document.querySelectorAll('.thb-quick-search');
      this.input = this.querySelector('.search-field');
      this.defaultTab = this.querySelector('.side-panel-content--initial');
      this.predictiveSearchResults = this.querySelector('.thb-predictive-search');
      this.cc = this.querySelector('.searchform--click-capture');

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));

      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
      this.input.addEventListener('focus', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));

      this.button.forEach((item, i) => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          document.body.classList.add('open-cc');
          if (this.is_drawer) {
            this.drawer.classList.add('active');
          }
          return false;
        });
      });

      this.cc?.addEventListener('click', this.close.bind(this));

      document.addEventListener('keyup', (e) => {
        if (e.code && e.code.toUpperCase() === 'ESCAPE') {
          this.close();
        }
      });
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        if (!this.is_drawer) {
          this.close();
        } else {
          // In drawer, return to default state when search is cleared
          this.returnToDefaultState();
        }
        return;
      }
      if (!this.is_drawer) {
        this.open();
      }
      this.predictiveSearchResults.classList.add('active');
      this.getSearchResults(searchTerm);
    }

    onFormSubmit(event) {
      // Always prevent default form submission
      event.preventDefault();
      
      const searchTerm = this.getQuery();
      
      if (!searchTerm.length) {
        // If empty, go back to default state
        this.returnToDefaultState();
        return;
      }
      
      // If search drawer is open, show results inline
      if (this.is_drawer && this.drawer.classList.contains('active')) {
        this.getSearchResults(searchTerm);
      } else {
        // If not in drawer, open drawer and show results
        this.open();
        this.getSearchResults(searchTerm);
      }
    }

    onFocus() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        this.predictiveSearchResults.innerHTML = '';
        return;
      }

      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {

      this.predictiveSearchResults.classList.add('loading');

      fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query,page&${encodeURIComponent('resources[limit]')}=10&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku&section_id=predictive-search`)
        .then((response) => {
          this.predictiveSearchResults.classList.remove('loading');
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          throw error;
        });
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      if (!this.is_drawer) {
        this.predictiveSearchResults.querySelector('#search-results-submit').classList.remove('button');
      }
      this.predictiveSearchResults.querySelector('#search-results-submit').addEventListener('click', (event) => {
        event.preventDefault();
        // Instead of submitting form, perform search inline
        const searchTerm = this.getQuery();
        if (searchTerm.length) {
          this.getSearchResults(searchTerm);
        }
      });
    }

    close() {
      this.predictiveSearchResults.setAttribute('inert', '');
      document.body.classList.remove('open-search');
    }
    open() {
      document.body.classList.add('open-search');
      this.predictiveSearchResults.removeAttribute('inert');
    }
    
    returnToDefaultState() {
      // Clear search results and show default state
      this.predictiveSearchResults.innerHTML = '';
      this.predictiveSearchResults.classList.remove('active');
      
      if (this.is_drawer) {
        // Show the default tab (promoted products) instead of search results
        const hasTabsPanel = this.drawer.querySelector('.side-panel-content--has-tabs');
        const defaultPanel = this.drawer.querySelector('.side-panel-content--initial');
        
        if (hasTabsPanel) {
          hasTabsPanel.classList.remove('active');
        }
        if (defaultPanel) {
          defaultPanel.style.display = 'block';
        }
      }
    }
  }
  customElements.define('search-form', SearchForm);
}